import { render } from "./AllNFTsList.vue?vue&type=template&id=05cefb7a&scoped=true"
import script from "./AllNFTsList.vue?vue&type=script&lang=js"
export * from "./AllNFTsList.vue?vue&type=script&lang=js"

import "./AllNFTsList.vue?vue&type=style&index=0&id=05cefb7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cefb7a"]])

export default __exports__